<script lang="ts">
  export let size = 16;
</script>

<svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M11.5936 10.4467L8.90031 8H7.09364L4.40031 10.4467C3.64698 11.1267 3.40031 12.1733 3.76698 13.12C4.13364 14.06 5.02698 14.6667 6.03364 14.6667H9.96031C10.9736 14.6667 11.8603 14.06 12.227 13.12C12.5936 12.1733 12.347 11.1267 11.5936 10.4467ZM9.21364 12.0933H6.78698C6.53364 12.0933 6.33364 11.8867 6.33364 11.64C6.33364 11.3933 6.54031 11.1867 6.78698 11.1867H9.21364C9.46698 11.1867 9.66698 11.3933 9.66698 11.64C9.66698 11.8867 9.46031 12.0933 9.21364 12.0933Z"
    class={$$props.class || "fill-current"}
  />
  <path
    d="M12.2331 2.87992C11.8664 1.93992 10.9731 1.33325 9.96645 1.33325H6.03311C5.02645 1.33325 4.13311 1.93992 3.76645 2.87992C3.40645 3.82659 3.65311 4.87325 4.40645 5.55325L7.09978 7.99992H8.90645L11.5998 5.55325C12.3464 4.87325 12.5931 3.82659 12.2331 2.87992ZM9.21311 4.81992H6.78645C6.53311 4.81992 6.33311 4.61325 6.33311 4.36659C6.33311 4.11992 6.53978 3.91325 6.78645 3.91325H9.21311C9.46645 3.91325 9.66645 4.11992 9.66645 4.36659C9.66645 4.61325 9.45978 4.81992 9.21311 4.81992Z"
    class={$$props.class || "fill-current"}
  />
</svg>
